import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { CheckFailureCount } from './model';
import { sharePct } from './imageQualityUtils';
import { QualityBar, useIqColors } from './meridianUi';

/**
 * Failed photos per check as labelled bars. Scaled to `scaleTo` when given (drill-down:
 * "18 / 23"), else to the largest check (site view). Rows only — the caller owns the card.
 */
export interface FailureBreakdownProps {
  breakdown: CheckFailureCount[];
  scaleTo?: number;
}

const FailureBreakdown: React.FC<FailureBreakdownProps> = ({ breakdown, scaleTo }) => {
  const colors = useIqColors();
  const sorted = [...breakdown].sort((left, right) => right.failedPhotos - left.failedPhotos);
  const max = scaleTo ?? Math.max(1, ...sorted.map(check => check.failedPhotos));
  return (
    <Column spacing="400" data-testid="iq-failure-breakdown">
      {sorted.map(check => (
        <Column key={check.checkId} spacing="200" data-testid={`iq-failure-${check.checkId}`}>
          <Row alignmentHorizontal="justify">
            <Text type="b400">{check.failureLabel}</Text>
            <Text type="h300">
              {scaleTo !== undefined
                ? `${check.failedPhotos.toLocaleString()} / ${scaleTo.toLocaleString()}`
                : check.failedPhotos.toLocaleString()}
            </Text>
          </Row>
          <QualityBar
            pct={sharePct(check.failedPhotos, max)}
            color={colors.failure(check.checkId)}
            width="100%"
            label={`${check.failureLabel} failures`}
          />
        </Column>
      ))}
    </Column>
  );
};

export default FailureBreakdown;
